// Styles object for Header component using sx prop
export const styles = {
  root: {
    flexGrow: 1,
  },
  menuButton: {},
  username: {
    fontSize: '14px',
  },
  accountButton: {
    borderRadius: '8px !important',
    padding: '6px 12px !important',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  title: {
    flexGrow: 1,
    marginLeft: '10px',
  },
  secondAppBar: {
    height: '50px',
    position: 'relative',
  },
  link: {
    marginLeft: '30px',
    fontFamily: 'AvenirNext',
    fontSize: '18px',
    textDecoration: 'none',
    padding: '10px 30px',
    color: '#fff',
    '&.active': {
      borderBottom: '3px solid #fff',
      fontWeight: 'bold',
      color: '#f4f4f4',
    },
  },
};

export default styles;
